import { useSyncExternalStore } from 'react';
import { isLocalMode, subscribeLocalMode } from '../lib/localMode';
import { useSyncEnabled } from './useSyncStatus';

/** Whether this device is in local mode: the flag is set and sync is not configured (a stale flag is ignored). */
export function useLocalMode(): boolean {
  const flagged = useSyncExternalStore(subscribeLocalMode, isLocalMode, () => false);
  const syncEnabled = useSyncEnabled();
  return flagged && !syncEnabled;
}
